import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { AnalyticsPanel } from "@/components/analytics/AnalyticsPanel";

export default function PageAnalytics() {
  const { id } = useParams();
  const [page, setPage] = useState(null);

  useEffect(() => {
    api.get(`/pages/${id}`).then(({ data }) => setPage(data));
  }, [id]);

  const title = page ? (page.type === "event" ? page.event_name : page.title) : "";

  return (
    <div className="min-h-screen bg-[#0B0E14] text-white" data-testid="page-analytics">
      <nav className="border-b border-white/10 px-6 py-4 flex items-center gap-4">
        <Link to="/dashboard" className="text-slate-400 hover:text-white" data-testid="analytics-back-link">
          <i className="fa-solid fa-arrow-left mr-2" />Dashboard
        </Link>
        <span className="font-display font-bold">{title || "Untitled"} · Analytics</span>
      </nav>

      <main className="max-w-4xl mx-auto px-6 py-10">
        {page && <AnalyticsPanel pageId={id} />}
      </main>
    </div>
  );
}
